import { App, Row } from "antd";
import { useCallback } from "react";

export const useConfirmationModal = (count: number, add: (values: any) => Promise<void>) => {
  const { modal } = App.useApp();

  const openModal = useCallback(
    (formData: any) =>
      modal.confirm({
        centered: true,
        icon: null,
        okText: "Send now",
        okType: "default",
        okButtonProps: {
          shape: "round"
        },
        cancelButtonProps: {
          shape: "round"
        },
        className: "confirm-create-admin",
        title: "Confirm Send",
        content: (
          <Row className="d-block">
            <Row className="mb-4">
              <p className="my-0">
                The email will be sent to <span className="text-md w-500">{count}</span> recipients and can't be undone.
              </p>
            </Row>
          </Row>
        ),
        onOk: async () => await add(formData)
      }),
    [modal, count, add]
  );

  return { openModal };
};
